import List from '@components/v2/ui/List/List';
import { Box } from '@mui/material';
import { ColumnVisibilityItem } from '../../columnsVisibility.types';
import ColumnRow from '../ColumnRow/ColumnRow';
interface ColumnsVisibilityListProps {
  columns: ColumnVisibilityItem[];
  onToggle: (key: string) => void;
}

const ColumnsVisibilityList = ({ columns, onToggle }: ColumnsVisibilityListProps) => {
  return (
    <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', paddingRight: 0.5 }}>
      <List>
        {columns.map((column) => (
          <ColumnRow key={column.key} column={column} onToggle={onToggle} />
        ))}
      </List>
    </Box>
  );
};

export default ColumnsVisibilityList;
